import { Divider, Grid, useTheme } from "@mui/material";
import { AsideNews, BigNewsSection } from "./index";
import { isEmpty } from "utils/helperFunction";

export default function NewsListPageHeader({ data }) {
  const theme = useTheme();

  return (
    <>
      <Grid
        container
        columnSpacing={{ md: 2, lg: 3 }}
        sx={{
          [theme.breakpoints.down("md")]: {
            background: "rgba(242, 242, 243, 0.5)",
            mb: "40px",
            px: 0,
            pb: "20px",
          },
        }}
      >
        <Grid item xs={12} md={8}>
          <header>
            <BigNewsSection {...data?.pages[0]?.data[0]} />
          </header>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            [theme.breakpoints.down("md")]: {
              px: "16px",
            },
          }}
        >
          {!isEmpty(data.pages[0].data.slice(1, 7)) && (
            <AsideNews news={data.pages[0].data.slice(1, 7)} />
          )}
        </Grid>
      </Grid>
      <Divider
        variant="middle"
        sx={{
          m: "60px 0 80px 0",
          [theme.breakpoints.down("md")]: {
            display: "none",
          },
        }}
      />
    </>
  );
}
